import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {useAccountInformation} from 'presentation/pages/private/hooks/useAccountInformation';
import {
	FINANCIAL_SUPPORT_PHONE,
	FINANCIAL_SUPPORT_PHONE_PPO,
	FINANCIAL_SUPPORT_WHATSAPP_LINK,
	FINANCIAL_SUPPORT_WHATSAPP_LINK_PPO,
} from 'presentation/pages/private/help/constants/channelsContacts';

export function useFinancialSupport() {
	const {isPPOPlan, businessPlan} = useAccountInformation();
	const {isEnabled: isHidePaymentSupportEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_HIDE_PAYMENT_SUPPORT_ICON,
	);

	return {
		canShowFinancialSupport: !(businessPlan && isHidePaymentSupportEnabled),
		financialSupportPhone: isPPOPlan ? FINANCIAL_SUPPORT_PHONE_PPO : FINANCIAL_SUPPORT_PHONE,
		financialSupportWhatsappLink: isPPOPlan
			? FINANCIAL_SUPPORT_WHATSAPP_LINK_PPO
			: FINANCIAL_SUPPORT_WHATSAPP_LINK,
	};
}
